import { initRedirectToCheckout } from '../../../../../Common/Resources/src_front/js/components/initRedirectToCheckout';
import { initSelectsubscribePlan } from '../components/initSelectsubscribePlan';
import { initSelectSubscriptionPeriod } from '../components/forms/initSelectSubscriptionPeriod';
import { initStickyTableHeader } from '../components/initStickyTableHeader';
import { initRenderPricesPage } from '../components/initRenderPricesPage';

window.addEventListener('DOMContentLoaded', handleOnDOMContentLoaded);

function handleOnDOMContentLoaded() {
    initRenderPricesPage();
    initRedirectToCheckout();
    initSelectsubscribePlan();
    initStickyTableHeader();
    initSelectSubscriptionPeriod();
}
